import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=a8f4cfa8&scoped=true&"
import script from "./StockList.vue?vue&type=script&lang=js&"
export * from "./StockList.vue?vue&type=script&lang=js&"
import style0 from "./StockList.vue?vue&type=style&index=0&id=a8f4cfa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f4cfa8",
  null
  
)

export default component.exports